module.exports = __webpack_public_path__ + "static/media/upskill.709c32ac.svg";